module.exports = __webpack_public_path__ + "static/media/4.ee3ec122.jpg";